import { useMutation } from '@tanstack/react-query'

import { addCartItem } from '../api'

const useAddCartItem = () => {
  return useMutation({
    mutationKey: ['addCartItem'],
    mutationFn: addCartItem,
  })
}

export default useAddCartItem
